export default {
  computed: {
    groupingAssetAssociationsList() {
      return this.groupings.reduce((list, grouping) => {
        if (grouping.assetAssociations) {
          grouping.assetAssociations.forEach(
            assetAssociation => list.push(assetAssociation)
          );
        }
        return list;
      }, []);
    },
    groupings() {
      return this.$store.getters['groupings/list'];
    },
  },
  methods: {
    getGroupingId(flashcardId) {
      return this.getGroupingIds(flashcardId)[0];
    },
    getGroupingIds(flashcardId, assetBType = 'V3Flashcard') {
      return this.getAssetAssociations(flashcardId, assetBType).map(aa => aa.assetAId);
    },
    getAssetAssociations(flashcardId, assetBType) {
      return this.groupingAssetAssociationsList
        .filter(aa => aa.assetBId === flashcardId && aa.assetBType === assetBType);
    },
    getAssetTrayGrouping(flashcard) {
      const assetAssociations = flashcard?.assetAssociations || [];
      const assetAssociationsWithScenarioBox = assetAssociations.filter(a => a.assetBType === 'Grouping');
      if (assetAssociationsWithScenarioBox.length === 0) return null;
      const groupingId = assetAssociationsWithScenarioBox[0].assetBId;
      return this.$store.getters['groupings/all'][groupingId];
    },
  },
};
